import React from "react";
import Style from "./ItemCategory.module.css";
import { itemListData } from "./itemListData";
const ItemCategory = ({ setCategoryItemKey, categoryItemKey, dispatch }) => {
  return (
    <section className={Style.componentHolder}>
      <div>
        <h5 htmlFor="itemList">نوع مرسوله</h5>
        <select
          id="itemList"
          className={Style.ListHolder}
          defaultValue={"0"}
          onChange={(e) => setCategoryItemKey(e.target.value)}
        >
          <option value="0" disabled>
            یک دسته بندی را انتخاب کنید
          </option>
          {itemListData?.map((item) => {
            return (
              <option key={item.key} value={item.key}>
                {item.lable}
              </option>
            );
          })}
        </select>
        <div className={Style.InputHolder}>
          <input
            type="text"
            placeholder="وزن و اندازه مرسوله"
            onChange={(e) =>
              dispatch({
                type: "SET_PRODUCT_DESCRIPTION",
                payload: e.target.value,
              })
            }
          />
        </div>
      </div>
      {categoryItemKey === "12" && (
        <div className={Style.InputHolder}>
          <input
            type="text"
            placeholder="دسته بندی را واردکنید"
            onChange={(e) =>
              dispatch({ type: "SET_CATEGORY_KEY", payload: e.target.value })
            }
          />
        </div>
      )}
    </section>
  );
};

export default ItemCategory;
